/** When your routing table is too long, you can split it into small modules**/
export default [
  {
    path: "/aboutus",
    name: "Aboutus",
    component: () => import("@/views/aboutus/Index"),
  },
  {
    path: "/aboutus/majors",
    name: "Majors",
    component: () => import("@/views/aboutus/Majors"),
  },
  {
    path: "/aboutus/ayinnamehs",
    name: "AyinNamehs",
    component: () => import("@/views/aboutus/AyinNamehs"),
  },
  {
    path: "/aboutus/ayindetail/:id",
    name: "AyinNamehsDetail",
    component: () => import("@/views/aboutus/AyinNamehDetails"),
  },
  {
    path: "/aboutus/schools",
    name: "schools",
    component: () => import("@/views/aboutus/Schools"),
  },
  {
    path: "/aboutus/schools/:id",
    name: "school",
    component: () => import("@/views/aboutus/SchoolDetails"),
  },
];
